export const ENVIRONMENT =
  import.meta.env.MODE ??
  process.env.NODE_ENV ??
  "development";

export const IS_DEV = ENVIRONMENT === "development";

/**
 * Whether this bundle was built for the functional-test harness.
 *
 * Distinct from {@link IS_DEV}: CLI E2E runs serve a PRODUCTION build through `vite preview`
 * (`start:e2e:preview`), so `MODE` is "production" and `IS_DEV` is false even though the app is under
 * test. Only the UI-mode runner uses the dev server. Anything a test needs to observe has to key off
 * this flag rather than off `IS_DEV`, or it will exist in exactly the mode nobody runs.
 *
 * `import.meta.env` is substituted at build time, so a real deployment — which never sets `VITE_E2E`
 * — compiles these branches out entirely.
 */
export const IS_E2E = import.meta.env.VITE_E2E === "true";

/**
 * The API address a functional-test browser has been handed at startup.
 *
 * One Vite server serves every Playwright worker, and each worker runs its own disposable API on its
 * own port, so the address compiled into the bundle cannot be right for more than one of them. The
 * harness defines this on the browser context before any application code runs
 * (`e2e/fixtures/proposal-collaboration.ts`), the same way it asks Ably for a WebSocket-only
 * transport. It is read only in a build made for E2E, so nothing a page script defines can point a
 * production bundle somewhere else.
 */
const E2E_API_BASE_URL =
  import.meta.env.VITE_E2E === "true"
    ? (globalThis as typeof globalThis & { __ATTORNEY_HUB_E2E_API_BASE_URL__?: string })
        .__ATTORNEY_HUB_E2E_API_BASE_URL__
    : undefined;

export const CONFIGURED_API_BASE_URL = E2E_API_BASE_URL?.trim() ?? import.meta.env.VITE_API_BASE_URL?.trim();

/**
 * Prefix for every Ably channel this browser subscribes to, when the harness has supplied one.
 *
 * The functional suite shards across machines and every shard shares one Ably application, while a
 * stack restored from the same seed dump signs in as the same users. Without a prefix two shards
 * name identical channels and receive each other's events, which arrives as a fetch of an entity
 * that exists only in the other shard's database. The API applies the same prefix from
 * `Ably:ChannelNamespace`, and mints tokens whose capabilities carry it, so the two must agree
 * exactly. Read only in a build made for E2E, and empty everywhere else.
 */
export const CONFIGURED_ABLY_CHANNEL_NAMESPACE =
  import.meta.env.VITE_E2E === "true"
    ? (
        globalThis as typeof globalThis & { __ATTORNEY_HUB_E2E_ABLY_NAMESPACE__?: string }
      ).__ATTORNEY_HUB_E2E_ABLY_NAMESPACE__?.trim()
    : undefined;
export const CONFIGURED_SITE_BASE_URL = import.meta.env.VITE_SITE_BASE_URL?.trim();
export const CONFIGURED_GOOGLE_PLACES_API_KEY = import.meta.env.VITE_GOOGLE_PLACES_API_KEY?.trim();
